export default "__VITE_ASSET__CqcfTN9g__"